<template>
  <es-loader v-if="loading" style="margin: 15rem"/>
  <es-exception v-else-if="loadingError"
    style="padding: 15rem"
    margin="0rem" size="4x"
    exceptionMessage="There was an issue. Please try again or contact your administrator."
  />
  <es-exception v-else-if="retirePerson === undefined || mergePerson === undefined"
    style="padding: 15rem"
    margin="0rem" size="4x"
    exceptionMessage="Student ID not found."
  />
  <div v-else class="document-container">
    <div>
      <div v-if="!viewConfirmationPage">
        <id-manager-info-panel
          v-if="!retiredConfirmation"
          style="margin-bottom: 1rem"
          @returnToList="cancelToList"
          @returnToDetails="cancelToDetails"
          :page="'comparePage'"
          :differentPersonTypes="differentPersonTypes"
          :loadingIdError="loadingIdError"
          :loadingIdErrorMsg="loadingIdErrorMsg"
          :retiredConfirmation="retiredConfirmation"
          :retirePendingNearMatchTransactions="retirePendingNearMatchTransactions"
        />
        <id-manager-info-panel
          v-if="retiredConfirmation"
          style="margin-bottom: 1rem"
          @returnToList="backToGroupsList"
          @returnToDetails="cancelToDetails"
          :mergePerson="mergePerson"
          :page="'comparePage'"
          :retiredConfirmation="retiredConfirmation"
          :retirePerson="retirePerson"
          :retiredResult="retiredResult"
        />
        <div class="columns is-desktop">
          <div class="column">
            <review-retire-merge-id-details
              @differentPersonTypes="personTypesDiff()"
              @mergePersonToConfirmationPage="storeMergePerson($event)"
              @viewRetireMergeConfirmationPage="showConfirmationPage"
              @retirePersonToConfirmationPage="storeRetirePerson($event)"
              @returnToList="cancelToList"
              :loadingIdError="loadingIdError && !canShowDataOnLoadingIdError"
              :loadingIdErrorMsg="loadingIdErrorMsg"
              :retirePerson="retirePerson"
              :retirePersonHistInfo="retirePersonHistInfo"
              :retirePersonLocInfo="retirePersonLocInfo"
              :mergePerson="mergePerson"
              :mergePersonHistInfo="mergePersonHistInfo"
              :mergePersonLocInfo="mergePersonLocInfo"
              :retiredConfirmation="retiredConfirmation"
              :retiredResult="retiredResult"
              :hasRetireIdMergePermission="hasRetireIdMergePermission"
              :hasRetireIdNoMergePermission="hasRetireIdNoMergePermission"
            />
          </div>
          <div class="column is-3">
            <quick-tips-review-retire-merge-id-details/>
          </div>
        </div>
      </div>
      <div v-else>
        <id-manager-info-panel
          @returnToDetails="cancelToDetails"
          :page="'confirmPage'"
          :retirePerson="retirePerson"
          :mergePerson="mergePerson"
          style="margin-bottom: 1rem"
        />
        <div class="columns is-desktop">
          <div class="column">
            <review-retire-merge-confirmation
              @cancelToList="cancelToList"
              @cancelToDetails="cancelToDetails"
              @showRetireConfirmedPage="storeRetiredResult($event)"
              :retirePersonHistInfo="retirePersonHistInfo"
              :retirePerson="retirePerson"
              :mergePerson="mergePerson"
            />
          </div>
          <div class="column is-3">
            <quick-tips-review-retire-merge-confirmation/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import IdManagerInfoPanel from '@/components/ID Manager Components/IdManagerInfoPanel.vue';
import ReviewRetireMergeIdDetails from '@/components/ID Manager Components/ReviewRetireMergeIdDetails.vue';
import ReviewRetireMergeConfirmation from '@/components/ID Manager Components/ReviewRetireMergeConfirmation.vue';
import QuickTipsReviewRetireMergeIdDetails from '@/components/ID Manager Components/QuickTipsReviewRetireMergeIdDetails.vue';
import QuickTipsReviewRetireMergeConfirmation from '@/components/ID Manager Components/QuickTipsReviewRetireMergeConfirmation.vue';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsException,
    EsLoader,
    IdManagerInfoPanel,
    ReviewRetireMergeIdDetails,
    ReviewRetireMergeConfirmation,
    QuickTipsReviewRetireMergeIdDetails,
    QuickTipsReviewRetireMergeConfirmation,
  },
  data() {
    return {
      differentPersonTypes: false,
      loading: false,
      loadingError: false,
      loadingIdError: false,
      loadingIdErrorMsg: null,
      canShowDataOnLoadingIdError: false,
      mergeIdSuccess: false,
      mergePerson: null,
      mergePersonHistInfo: null,
      mergePersonLocInfo: null,
      retirePerson: null,
      retirePersonHistInfo: null,
      retirePersonLocInfo: null,
      retiredConfirmation: false,
      retiredResult: null,
      viewConfirmationPage: false,
      hasRetireIdMergePermission: true,
      hasRetireIdNoMergePermission: true,
      retirePendingNearMatchTransactions: [],
    };
  },
  created() {
    this.onLoad();
  },
  computed: {
    ...mapGetters([
      'userDistricts',
      'userPersonTypes',
      'userSchools',
    ]),
    ...mapGetters('lookups', [
      'activeEthnicities',
      'activeEthnicSubGroups',
      'activeGenders',
      'activeGrades',
      'activeRaces',
      'activeResidencyStatuses',
      'activeStates',
      'defaultPersonType',
    ]),
    setOfUserDistricts() {
      return this.userDistricts.map(a => a.code);
    },
    setOfUserPersonTypes() {
      return this.userPersonTypes.map(a => a.code);
    },
    setOfUserSchools() {
      return this.userSchools.map(a => a.code);
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadEthnicities',
      'loadEthnicSubGroups',
      'loadGenders',
      'loadGrades',
      'loadPersonTypes',
      'loadRaces',
      'loadResidencyStatuses',
      'loadStates',
    ]),
    backToGroupsList() {
      this.clearOutPreviousData();
      this.viewConfirmationPage = false;
      this.viewDupGroupDetails = false;
    },
    cancelToList() {
      this.clearOutPreviousData();
      this.viewDupGroupDetails = true;
      this.viewConfirmationPage = false;
    },
    cancelToDetails() {
      this.showConfirmationPage();
    },
    clearOutPreviousData() {
      this.mergePerson = null;
      this.mergeId = null;
      this.retirePerson = null;
      this.retireId = null;
      this.retiredConfirmation = false;
      this.retiredResult = null;
    },
    async onLoad() {
      this.loading = true;
      this.loadingError = false;
      try {
        await Promise.all([
          this.loadEthnicities(),
          this.loadEthnicSubGroups(),
          this.loadGrades(),
          this.loadGenders(),
          this.loadPersonTypes(),
          this.loadRaces(),
          this.loadResidencyStatuses(),
          this.loadStates(),
          this.viewComparePageDetails(),
        ]);
      } catch (error) {
        this.loadingError = true;
      }
      this.loading = false;
    },
    personTypesDiff() {
      this.differentPersonTypes = true;
    },
    showConfirmationPage() {
      this.viewConfirmationPage = !this.viewConfirmationPage;
    },
    showError(error) {
      this.showNotification('danger', [error]);
    },
    storeRetirePerson(data) {
      this.retirePerson = data;
    },
    storeMergePerson(data) {
      this.mergePerson = data;
    },
    async validateData() {
      try {
        this.loadingError = false;
        const { retireId } = this.$route.query;
        if (!retireId) return;

        const response = await axios.get(`idmanager/validate?id=${retireId}`);
        // The BE returns the message already containing the ids.
        // We need to parse the strings and only get the ids.
        if (response.data.message) {
          const regex = /See Transactions?:\s*(?:[^:]+:\s*)?([\d,]+)/i;
          const match = response.data.message.match(regex);

          if (match && match[1]) {
            this.retirePendingNearMatchTransactions = match[1]
              .split(',')
              .map(id => id.trim())
              .filter(id => /^\d+$/.test(id));
          }

          if (this.retirePendingNearMatchTransactions
            && this.retirePendingNearMatchTransactions.length) {
            this.hasRetireIdMergePermission = false;
            this.hasRetireIdNoMergePermission = false;
          }
        }
      } catch (err) {
        this.loadingError = true;
      }
    },
    async viewComparePageDetails() {
      const { retireId, mergeId = null } = this.$route.query;
      this.loading = true;
      this.loadingError = false;
      try {
        const retireResults = await axios.post('person-search/by-id', {
          idType: 'statePersonId',
          id: retireId,
        });

        if (retireResults.status === 200) {
          if (!retireResults.data.data.length) {
            this.showNotification('danger', ['The \'ID to Retire\' not found.']);
            this.loadingIdError = true;
            this.canShowDataOnLoadingIdError = false;
            this.loadingIdErrorMsg = 'The \'ID to Retire\' not found.';
          } else {
            [this.retirePerson] = retireResults.data.data;
            if (this.retirePerson.retired) {
              this.showNotification('danger', ['The \'ID to Retire\' is already Retired.']);
              this.loadingIdError = true;
              this.canShowDataOnLoadingIdError = false;
              this.loadingIdErrorMsg = 'The \'ID to Retire\' is already Retired.';
            } else {
              this.hasRetireIdNoMergePermission = this.hasModule('PRSID:IDENT:RETIREID');
              const hasUserDistrictAccess = this.setOfUserDistricts.length === 0
                || this.setOfUserDistricts.includes(this.retirePerson.districtCode);
              const hasUserSchoolAccess = this.setOfUserSchools.length === 0
                || this.setOfUserSchools.includes(this.retirePerson.schoolCode);
              const hasUserPersonTypeAccess = this.setOfUserPersonTypes.length === 0
                || this.setOfUserPersonTypes.includes(this.retirePerson.personType);
              if (!hasUserDistrictAccess) {
                this.hasRetireIdNoMergePermission = false;
                this.canShowDataOnLoadingIdError = true;
                this.loadingIdError = true;
                this.loadingIdErrorMsg = `User is not authorized to submit records to the specified district : ${this.retirePerson.districtCode}`;
                this.showError(this.loadingIdErrorMsg);
              } else if (!hasUserSchoolAccess) {
                this.hasRetireIdNoMergePermission = false;
                this.canShowDataOnLoadingIdError = true;
                this.loadingIdError = true;
                this.loadingIdErrorMsg = `User is not authorized to submit records to the specified school : ${this.retirePerson.schoolCode}`;
                this.showError(this.loadingIdErrorMsg);
              } else if (!hasUserPersonTypeAccess) {
                this.hasRetireIdNoMergePermission = false;
                this.canShowDataOnLoadingIdError = true;
                this.loadingIdError = true;
                this.loadingIdErrorMsg = `User is not authorized to submit records to the specified person type : ${this.retirePerson.personType}`;
                this.showError(this.loadingIdErrorMsg);
              }
              const sort = [{
                field: 'lastUpdateDate',
                order: 'DESC',
              }];
              const params = new URLSearchParams();
              params.append('pageSize', '12');
              params.append('sort', JSON.stringify(sort));
              if (mergeId) {
                const mergeResults = await axios.post('person-search/by-id', {
                  idType: 'statePersonId',
                  id: mergeId,
                });
                if (mergeResults.status === 200) {
                  if (!mergeResults.data.data.length) {
                    this.showNotification('danger', ['The \'ID to Merge to\' not found.']);
                    this.loadingIdError = true;
                    this.canShowDataOnLoadingIdError = false;
                    this.loadingIdErrorMsg = 'The \'ID to Merge to\' not found.';
                  } else {
                    [this.mergePerson] = mergeResults.data.data;
                    this.hasRetireIdMergePermission = this.hasModule('PRSID:IDENT:RETIREID');
                    const hasUserMergeDistrictAccess = this.setOfUserDistricts.length === 0
                      || this.setOfUserDistricts.includes(this.mergePerson.districtCode);
                    const hasUserMergeSchoolAccess = this.setOfUserSchools.length === 0
                      || this.setOfUserSchools.includes(this.mergePerson.schoolCode);
                    const hasUserMergePersonTypeAccess = this.setOfUserPersonTypes.length === 0
                      || this.setOfUserPersonTypes.includes(this.mergePerson.personType);
                    if (!hasUserMergeDistrictAccess) {
                      this.hasRetireIdMergePermission = false;
                      this.canShowDataOnLoadingIdError = true;
                      this.loadingIdError = true;
                      this.loadingIdErrorMsg = `User is not authorized to submit records to the specified district : ${this.mergePerson.districtCode}`;
                      this.showError(this.loadingIdErrorMsg);
                    } else if (!hasUserMergeSchoolAccess) {
                      this.hasRetireIdMergePermission = false;
                      this.canShowDataOnLoadingIdError = true;
                      this.loadingIdError = true;
                      this.loadingIdErrorMsg = `User is not authorized to submit records to the specified school : ${this.mergePerson.schoolCode}`;
                      this.showError(this.loadingIdErrorMsg);
                    } else if (!hasUserMergePersonTypeAccess) {
                      this.hasRetireIdMergePermission = false;
                      this.canShowDataOnLoadingIdError = true;
                      this.loadingIdError = true;
                      this.loadingIdErrorMsg = `User is not authorized to submit records to the specified person type : ${this.mergePerson.personType}`;
                      this.showError(this.loadingIdErrorMsg);
                    }

                    if (this.mergePerson.retired) {
                      this.showNotification('danger', ['The \'ID to Merge to\' is already Retired.']);
                      this.loadingIdError = true;
                      this.canShowDataOnLoadingIdError = false;
                      this.loadingIdErrorMsg = 'The \'ID to Merge to\' is already Retired.';
                    } else {
                      const temp3 = await axios.get(`person/${mergeId}/location`);
                      [this.mergePersonLocInfo] = temp3.data;
                      const temp4 = await axios.get(`person/${mergeId}/history`, { params });
                      this.mergePersonHistInfo = temp4.data;
                      this.mergeIdSuccess = true;
                    }
                  }
                }
              }
              if (mergeId === null || this.mergeIdSuccess) {
                const temp = await axios.get(`person/${retireId}/location`);
                [this.retirePersonLocInfo] = temp.data;
                const temp2 = await axios.get(`person/${retireId}/history`, { params });
                this.retirePersonHistInfo = temp2.data;
              }
              await this.validateData();
            }
          }
        }
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    async storeRetiredResult(result) {
      this.loading = true;
      this.loadingError = false;
      this.retiredConfirmation = true;
      this.retiredResult = result;
      try {
        const retireResults = await axios.get(`retired-person/${result.reference.idRetired}/profile`);
        this.retirePerson = retireResults.data;
        const temp = await axios.get(`retired-person/${result.reference.idRetired}/location`);
        [this.retirePersonLocInfo] = temp.data;
        const sort = [{
          field: 'lastUpdateDate',
          order: 'DESC',
        }];
        const params = new URLSearchParams();
        params.append('pageSize', '12');
        params.append('sort', JSON.stringify(sort));
        const temp2 = await axios.get(`retired-person/${result.reference.idRetired}/history`, { params });
        this.retirePersonHistInfo = temp2.data;
        if (result.reference.idMerged) {
          const mergeResults = await axios.get(`person/${result.reference.idMerged}/profile`);
          this.mergePerson = mergeResults.data;
          const temp3 = await axios.get(`person/${result.reference.idMerged}/location`);
          [this.mergePersonLocInfo] = temp3.data;
          const temp4 = await axios.get(`person/${result.reference.idMerged}/history`, { params });
          this.mergePersonHistInfo = temp4.data;
        } else {
          this.mergePerson = null;
        }
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
        this.viewConfirmationPage = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .column
    height: 100%
    padding: 0.5rem !important
</style>
